<template>
  <div class="shapes">
    <div v-show="!S_GlobalSearch" style="padding-bottom: 50px;">
      <section class="chart">
        <div class="commerical">会员可商用</div>
        <img
          src="/static/img/chart78.0.jpg"
          v-if="StyleMsg === 78"
          alt
          @click="showChart = !showChart"
        />
        <img
          src="/static/img/chart79.0.jpg"
          v-if="StyleMsg === 79 || StyleMsg === 80"
          alt
          @click="showChart = !showChart"
        />
        <img
          src="/static/img/chart81.0.jpg"
          v-if="StyleMsg === 81"
          alt
          @click="showChart = !showChart"
        />
        <img
          src="/static/img/chart90.0.jpg"
          v-if="StyleMsg === 91"
          alt
          @click="showChart = !showChart"
        />
        <img
          src="/static/img/chart91.0.jpg"
          v-if="StyleMsg === 92"
          alt
          @click="showChart = !showChart"
        />
        <span>智能图表</span>
        <p class="expand-line" v-show="showChart"></p>
        <switchChartType :chartFrom="chartFrom" v-show="showChart" :showMark="true"></switchChartType>
      </section>

      <div
        class="data-body"
        v-for="(item, index) in category"
        :key="item.id"
        :class="{'operation': dataArray['_' + item.id].judge}"
        :style="{'height': dataArray['_' + item.id].judge ? 'auto' : '140px' }"
      >
        <sectionCategory
          :itemData="item"
          :itemIndex="index"
          :boxName="boxName"
          @scrollTop="scrollTop"
          @getData="getData"
          @dataBoxAction="dataBoxAction"
        />

        <div
          class="body-list"
          :style="{
            'height': (dataArray['_' + item.id].data.length? (dataArray['_' + item.id].WFSheight + 30 + 'px') : '150px'),
            // --每个slide文件都会有注释这个css属性，禁止分组图固定在素材栏上方--
            // 'margin-top': fixTopId.id === ('_' + item.id) ? '120px' : '0px',
            // ----
            'padding-top' : (dataArray['_' + item.id].data.length? (dataArray['_' + item.id].WFSheight - 10 + 'px') : '50px'),
          }"
        >
          <FilterSprites
            v-model="dataArray['_' + item.id]"
            :boxName="boxName"
            :cgid="'_' + item.id"
            :previewData="previewData"
            :dataArray="dataArray"
            :loading="loading"
          />

          <div
            class="item"
            v-for="(itemL, indexL) in  dataArray['_' + item.id].data"
            @mouseenter="loadLottieShapes(itemL, {index: indexL , id:'shapes_'+item.id}, true) "
            @mouseleave="loadLottieShapes(itemL, {index: indexL , id:'shapes_'+item.id}, false)"
            @click="
              slidAddSprites(itemL);
              materialPushAnalysis({type: 'shape', id: item.id, name: item.name});
            "
            :key="itemL.id"
            :style="{
              top : itemL.topWFC + 'px',
              left: itemL.leftWFC + 'px'
            }"
          >
            <img
              :class="{'Imglottie': itemL.fileType === 8, }"
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              width="auto"
              height="100%"
            />
            <div class="mask" :class="{'Clottie': itemL.fileType === 8, }" :ref="'shapes_'+item.id"></div>

            <vipLabel :payType="itemL.payType" :itemData="itemL" :boxName="boxName" />

            <el-tooltip effect="dark" content="收藏" placement="top" :open-delay="1000">
              <i
                class="collection_sprite_icon"
                :class="[
                {'collection_sprite_icon_active' : itemL.favorites},
                'vipResource_' + itemL.id
              ]"
                @mouseover="
                collectionSpriteIconTit($event);
                stopDocument($event);
              "
                @click="
                stopDocument($event);
                collectionSpriteIconFS(itemL, $event)
              "
              ></i>
            </el-tooltip>
          </div>

          <div
            v-loading="loading"
            v-if="loading"
            element-loading-background="rgba(0, 0, 0, 0)"
            element-loading-text="加载中..."
            element-loading-spinner="el-laihua-loading"
            style="width: 100%;height: 20px; margin-top: 50px;"
          ></div>
        </div>
      </div>

      <SwitchStyle />
      <CategoryPrompt
        v-model="fixTopId"
        :windowMove="windowMove"
        :judgeFixed="judgeFixed"
        :boxName="boxName"
        :dataArray="dataArray"
      />
    </div>

    <div v-show="S_GlobalSearch">
      <Search
        :boxName="boxName"
        :dataMsg="dataMsg"
        v-on:addsprite="slidAddSprites"
        :searchDataArray="dataArray"
        :loading="loading"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import rightnavSlide from "../../mixins/rightnavSlide";
import switchChartType from "../../popups/content/switchChartType";
import Analysis from "../../mixins/analysis/materialBu";
import Search from "./search/search";

export default {
  mixins: [rightnavSlide, Analysis],
  data() {
    return {
      chartFrom: "rightNav",
      boxName: "shapes", // 素材盒子的名字
      dataArray: [], // 数据数组
      scollTop: {
        // 控制滚动条的数据
        default: 140, // 默认添加的高度
        Incremental: 140, // 单个分类的高度
        material: 90, // 单个元素的高度
        rowNum: 2 // 每行个数
      },
      dataSet: {
        // 请求数据对象
        pIndex: 0,
        type: 15,
        sOfPage: 24,
        fPage: 24,
        style: null
      },
      user: false,
      showHot: false,
      showBasicShapes: false,
      showChart: false,
      showArrows: false,
      waterfallComputeData: {
        // 瀑布流的数据
        listNum: 2 // 瀑布流的列数
      },
      previewData: [
        {
          name: "静态素材",
          data: "6,29",
          type: "static"
        },
        {
          name: "动态素材",
          data: 8,
          type: "dynamic"
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "TopNav_Size",
      "MaterialPane_Size",
      "TOOL",
      "SpriteOperation",
      "SelectSprites_Msg",
      "StyleDataMsg",
      "Window_Size",
      "SpriteBeforeSwap"
    ])
  },
  mounted() {
    this.$bus.on("insert-chart", data => {
      // data: {
      //   style: {},
      //   data: {},
      //   resourceId: ***,
      //   fileType: ***,
      //   chartType: ***
      // }
    });
  },
  methods: {
    insertArrow() {
      // todo
    },
    insertShape(type) {
      if (this.SpriteOperation === "swap") {
        this.swapShape(type);
        return;
      }
      switch (type) {
        case "rect":
        case "ellipse":
          this.TOOL.addSprite("Shape", {
            category: type,
            style: {
              width: 300,
              height: 100,
              color: "#FFD700"
            }
          });
          break;
        case "circle":
          this.TOOL.addSprite("Shape", {
            category: type,
            style: {
              diameter: 200,
              height: 200,
              color: "#FFD700"
            }
          });
          break;
      }
    },
    swapShape(type) {
      let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;
      let obj = {
        sprite,
        typeForAdd: "Shape"
      };
      switch (type) {
        case "rect":
        case "ellipse":
          this.TOOL.swapSprite(
            {
              ...obj,
              optionForAdd: {
                category: type,
                style: {
                  width: 300,
                  height: 100,
                  color: "#FFD700"
                }
              }
            },
            true
          );
          break;
        case "circle":
          this.TOOL.swapSprite(
            {
              ...obj,
              optionForAdd: {
                category: type,
                style: {
                  diameter: 200,
                  height: 200,
                  color: "#FFD700"
                }
              }
            },
            true
          );
          break;
      }
    }
  },
  components: {
    switchChartType,
    Search
  }
};
</script>

<style scoped lang="scss">
.shapes {
  width: 270px;

  section {
    width: 270px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #474261;
    margin-bottom: 5px;
    background: #fff;
    img {
      width: 270px;
      height: 90px;
      background-color: #87307e;
      border-radius: 8px;
      margin-bottom: 9px;
      cursor: pointer;
    }
    .expand-line {
      position: relative;
      width: 100%;
      height: 2px;
      background-color: #d6d3d3;
      &:before {
        content: "";
        position: absolute;
        top: -3px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 10px;
        height: 10px;
        background: #fff;
        transform: rotate(135deg);
        border-top: 2px solid #d6d3d3;
        border-right: 2px solid #d6d3d3;
      }
    }
  }
  .chart {
    position: relative;
    overflow: hidden;
    .commerical {
      position: absolute;
      top: 14px;
      right: -19px;
      width: 127px;
      height: 20px;
      background-image: linear-gradient(-90deg, #e3a995 0%, #fffbed 100%);
      box-shadow: 0px 0px 8px 0px rgba(42, 46, 70, 0.43);
      transform: rotate(35deg);
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 20px;
      letter-spacing: 0px;
      color: #010101;
      padding-left: 15px;
    }
  }
  .basic-shapes {
    .regular-shapes {
      width: 100%;
      height: 140px;
      background-color: #fff;
      display: flex;
      justify-content: space-around;
      align-items: center;
      border-bottom: 2px solid #ddddec;
      img {
        display: block;
        width: 60px;
        height: 50px;
        background-color: #f0f0f8;
        margin-top: 15px;
        margin-bottom: 15px;
        border-radius: 4px;
        cursor: pointer;
      }
    }
  }
  .data-body {
    padding: 22px 0;
    height: 140px;
    overflow: hidden;

    .body-list {
      border-top: 2px solid #d6d3d3;
      position: relative;
      min-height: 88px;
      &:before {
        content: "";
        position: absolute;
        top: -6px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 10px;
        height: 10px;
        background: #fff;
        transform: rotate(135deg);
        border-top: 2px solid #d6d3d3;
        border-right: 2px solid #d6d3d3;
      }

      .item {
        width: 130px;
        height: 73px;
        border-radius: 3px;
        background: #fff;
        position: absolute;
        background-color: #fafafd;
        border: solid 2px #dbdff0;
        overflow: hidden;

        &:hover {
          border-color: #5778fb;
          .Clottie {
            opacity: 1;
            z-index: 5;
          }
          > .Imglottie {
            opacity: 0;
            z-index: 0;
          }
          .modify {
            opacity: 1;
          }
        }

        > img {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          z-index: 0;
          margin: auto;
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
        }

        .mask,
        .Clottie {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          opacity: 0;
          z-index: 0;
          transition: all 0.3s;
          height: 100%;
        }

        .modify,
        .label {
          position: absolute;
          bottom: 5px;
          right: 5px;
          width: 30px;
          height: 18px;
          background: #d83d60;
          color: #fff;
          border-radius: 5px;
          line-height: 18px;
        }
        .modify {
          width: 35px;
          height: 35px;
          opacity: 0;
          cursor: pointer;
          transition: all 0.3s;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide/shapes.vue